import uniqueImage from '../assets/images/uniqueImage.png'; // Adjust the path as needed

const UniqueFeatures = () => {
  return (
    <section className="ftco-section ftco-no-pb">
<div className="container">

    
  <div className="row mt-3">
    <div className=" col-md-12 order-md-first ">
      <div className="text px-4">
    
              <p>
                <img src={uniqueImage} alt="SRN Chairman" className="img-fluid" width={844} /> 
               
                         </p>
        </div>
    </div>

  
  </div>  
  </div>

    </section>
  );
};

export default UniqueFeatures;
